"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeaderStyle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NavHeaderStyle = _styledComponents.default.div.withConfig({
  displayName: "NavHeaderstyles__NavHeaderStyle",
  componentId: "sc-1bwtxk4-0"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;.left{display:flex;align-items:center;cursor:pointer;svg{width:", "px;height:", "px;}label{margin-left:5px;margin-right:24px;", ";color:", ";}}"], ({
  iconSize
}) => iconSize, ({
  iconSize
}) => iconSize, _shared.theme.typography.body, _shared.theme.palette.brand.primary.charcoal);

exports.NavHeaderStyle = NavHeaderStyle;